export default {
  path: '/order_states',
  name: 'order_states',
  component: () => import('../components/orderstate/Layout'),
  redirect: { name: 'OrderStateList' },
  meta: {
    breadcrumb: 'order.states',
  },
  children: [
    {
      name: 'OrderStateList',
      path: '',
      component: () => import('../views/orderstate/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'OrderStateCreate',
      path: 'new',
      component: () => import('../views/orderstate/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'OrderStateUpdate',
      path: ':id/edit',
      component: () => import('../views/orderstate/Update'),
      meta: {
        breadcrumb: 'order.state',
      },
    },
    {
      name: 'OrderStateShow',
      path: ':id',
      component: () => import('../views/orderstate/Show'),
      meta: {
        breadcrumb: 'order.state',
      },
    }
  ]
};
